var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none",
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "accent",
    fillRule: "evenodd",
    d: "M2.58 3.5c0-.41.34-.75.75-.75h12c.42 0 .75.34.75.75v12c0 .41-.33.75-.75.75h-12a.75.75 0 0 1-.75-.75v-12Zm1.5.75v10.5h10.5V4.25H4.08Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.08 10.25a.75.75 0 0 1 0-1.5h16.5a.75.75 0 1 1 0 1.5H1.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignVertical);
export default __webpack_public_path__ + "static/media/alignVertical.f4ef1ed01962e45c1c73c346b504aace.svg";
export { ForwardRef as ReactComponent };